import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Connects to data-controller="tom-select"
export default class extends Controller {
  static values = {
    url: String,
    placeholder: String,
    minInput: { type: Number, default: 2 },
    preload: { type: Boolean, default: false },
    noResults: String
  }

  connect() {
    const config = {
      create: false,
      allowEmptyOption: true,
      placeholder: this.placeholderValue || this.element.getAttribute("placeholder") || "",
      sortField: [ { field: "$order" } ]
    }

    if (this.hasNoResultsValue) {
      config.render = config.render || {}
      config.render.no_results = (data, escape) => {
        return `<div class="no-results">${escape(this.noResultsValue)}</div>`
      }
    }

    if (this.hasUrlValue) {
      config.valueField = "value"
      config.labelField = "text"
      config.searchField = "text"
      config.preload = this.preloadValue ? "focus" : false
      config.load = (query, callback) => {
        const keyword = query.trim()
        if (!this.preloadValue && keyword.length < this.minInputValue) {
          return callback()
        }

        const params = new URLSearchParams()
        params.append("q", keyword)

        const excludeId = this.element.dataset.excludeId
        if (excludeId) {
          params.append("exclude_id", excludeId)
        }

        const separator = this.urlValue.includes("?") ? "&" : "?"

        fetch(`${this.urlValue}${separator}${params.toString()}`, {
          headers: { Accept: "application/json" }
        })
          .then((response) => response.json())
          .then((json) => callback(json))
          .catch(() => callback())
      }
    }

    this.select = new TomSelect(this.element, config)
    this.dispatch("ready", { detail: { instance: this.select } })
  }

  disconnect() {
    if (!this.select) return

    this.dispatch("destroy", { detail: { instance: this.select } })
    this.select.destroy()
  }
}
